import { Helmet } from 'react-helmet-async';

import MatchingByClientTable from './matching-by-client-table';

export default function MatchingByClient() {
  
  return (
    <>
      <Helmet>
        <title>Client Matching</title>
      </Helmet>
      <MatchingByClientTable/>
    </>
  )
}
